import React from "react";
import "./Overview.css";
import RequestChart from "./RequestChart";
import DistributionChart from "./DistributionChart";
const Overview = () => {
  return (
    <div className="overview">
      <div className="overview-main">
        <div className="left-overview">
          <h3>API Request</h3>
          <div className="request-chart">
            <RequestChart />
          </div>
        </div>
        <div className="right-overview">
          <h3>API Error Distribution</h3>
          <div className="distrubution-chart">
            <DistributionChart />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Overview;
